import React, { ReactElement } from 'react';
import {
  Col, Heading, Link, Row, Tag,
} from 'idsk-react-components';
import './pripomienkaRow.scss';
import { useParams } from 'react-router';
import PripomienkaData from '../PripomienkaData/PripomienkaData';
import mapDate from '../../../../function/mapDate';
import Pripomienka from '../../../../model/pripomienka/Pripomienka';
import TypPripomienky from '../../../../model/pripomienka/TypPripomienky';
import routes from '../../../../routing/routes';
import PripomienkaOdoslanaTag from '../../../PripomienkaOdoslanaTag';
import AssignMeCheckbox from '../AssignMeCheckbox/AssignMeCheckbox';
import Uuid from '../../../../model/Uuid';
import AssignMePripomienkaButton from '../../../AssignMePripomienkaButton';
import { stavPripomienkyToTagClass } from '../../../../model/pripomienka/StavPripomienky';
import UserRole from '../../../../model/currentuser/UserRole';
import Secured from '../../../Secured';
import { processInCorrectStates } from '../../../../function/permissions';
import { useUserContext } from '../../../../context/UserContext';

interface Props {
  pripomienka: Pripomienka;
  setAssignedList?: (assignedList: Array<Uuid>) => void;
  assignedList?: Array<Uuid>;
  reloadPripomienkaListPage?():void;
  reloadFilterData?():void;
}

const PripomienkaRow = ({
  pripomienka,
  assignedList,
  setAssignedList,
  reloadPripomienkaListPage,
  reloadFilterData,
}: Props): ReactElement => {
  // @ts-ignore
  const { type, year, index } = useParams<{ type: string, year: number, index: number }>();

  const { legislationProcess } = useUserContext();

  const getDetailUrl = (): string => (pripomienka.typ === TypPripomienky.HROMADNA
    ? routes.hromadnePripomienky.detail.withParams(type, year, index, pripomienka.uuid)
    : routes.pripomienky.detail.withParams(type, year, index, pripomienka.uuid));

  const getVyhodnotUrl = (): string => (pripomienka.typ === TypPripomienky.HROMADNA
    ? routes.hromadnePripomienky.evaluate.withParams(type, year, index, pripomienka.uuid)
    : routes.pripomienky.evaluate.withParams(type, year, index, pripomienka.uuid));

  return (
    <div className="pripomienka-row">
      <Row>
        <Col>
          <AssignMeCheckbox
            id={pripomienka.uuid}
            assignedList={assignedList}
            setAssignedList={setAssignedList}
          >
            <Heading className="pripomienka-row-heading" size="s">
              {pripomienka.pripomienkujuciSubjekt}
            </Heading>
          </AssignMeCheckbox>
        </Col>
      </Row>
      <Row>
        <Col width="one-quarter">
          <PripomienkaData label="Dátum:" value={mapDate(pripomienka.datumPripomienky)} />
          <PripomienkaData label="Pripomienka k:" value={pripomienka.pripomienkaK} />
          <PripomienkaData label="Typ:" value={pripomienka.typ} />
          <Secured allowForRoles={[UserRole.VYHODNOCOVATEL, UserRole.SUPERADMIN]}>
            {pripomienka.priradeny
              ? (<PripomienkaData label="Priradená:" value={pripomienka.priradeny} />)
              : <PripomienkaData label="Priradená:" value="Nepriradená" />}
          </Secured>
          {pripomienka.pocetPodporovatelov !== null && pripomienka.pocetPodporovatelov >= 0 && (
            <PripomienkaData label="Podporovatelia:" value={pripomienka.pocetPodporovatelov} />
          )}
          {pripomienka.odoslana !== null && (
            <PripomienkaOdoslanaTag isOdoslana={pripomienka.odoslana} />
          )}
          {pripomienka.stav && (
          <Tag
            className="pripomienka-stav-tag"
            size="small"
            type={stavPripomienkyToTagClass(pripomienka.stav)}
          > {pripomienka.stav}
          </Tag>
          )}
        </Col>
        <Col width="three-quarters">
          <div className="text-overflow">
            {pripomienka.text}
          </div>
        </Col>
      </Row>
      <Row className="pripomienka-detail-button-row">
        <Col>
          <Secured
            allowForRoles={[UserRole.VYHODNOCOVATEL]}
            additionalCheck={processInCorrectStates(legislationProcess)}
          >
            <Link
              className="vyhodnotit-button"
              type="button-action"
              size="large"
              to={getVyhodnotUrl()}
            >Vyhodnotiť
            </Link>
          </Secured>
          <AssignMePripomienkaButton
            pripomienkaUuid={pripomienka.uuid}
            reloadPage={reloadPripomienkaListPage}
            reloadFilterData={reloadFilterData}
            legislationProcess={legislationProcess}
          />
          <Link
            className="detail-button"
            type="button-primary"
            size="large"
            to={getDetailUrl()}
          >Detail
          </Link>
        </Col>
      </Row>
    </div>
  );
};

export default PripomienkaRow;
